export default "__VITE_ASSET__DcUYAQ27__"